import {
  ActivityType,
  DisclosureType,
  ETaxBurden,
  HighMediumLowType,
  HolderTaxAgentType,
  InvestmentsGoalsType,
  LegalEntityTaxAgentType,
  OwnershipType,
  PerspectivesType,
  PublicFundTaxAgentType,
  TaxAgentType,
  TaxAgentWithBrokerType,
} from './types';

export const ActivityList = [
  {
    key: ActivityType.active,
    label: 'forms_assets:common.enums.activity.active',
  },
  {
    key: ActivityType.passive,
    label: 'forms_assets:common.enums.activity.passive',
  },
];

export const InvestmentsGoalsList = [
  {
    label: 'forms_assets:common.enums.goal.investment',
    key: InvestmentsGoalsType.investment,
  },
  {
    label: 'forms_assets:common.enums.goal.personal',
    key: InvestmentsGoalsType.personal,
  },
  {
    label: 'forms_assets:common.enums.goal.saving',
    key: InvestmentsGoalsType.saving,
  },
];

export const PerspectivesList = [
  {
    label: 'forms_assets:common.enums.outlook.sell',
    key: PerspectivesType.sell,
  },
  {
    label: 'forms_assets:common.enums.outlook.onHold',
    key: PerspectivesType.onHold,
  },
  {
    label: 'forms_assets:common.enums.outlook.develop',
    key: PerspectivesType.develop,
  },
];

export const HighMediumLowList = [
  {
    label: 'forms_assets:common.enums.highMediumLow.high',
    key: HighMediumLowType.high,
  },
  {
    label: 'forms_assets:common.enums.highMediumLow.medium',
    key: HighMediumLowType.medium,
  },
  {
    label: 'forms_assets:common.enums.highMediumLow.low',
    key: HighMediumLowType.low,
  },
];

export const TaxBurdenList = [
  {
    label: 'forms_assets:common.enums.taxBurden.high',
    key: ETaxBurden.HIGH,
  },
  {
    label: 'forms_assets:common.enums.taxBurden.medium',
    key: ETaxBurden.MEDIUM,
  },
  {
    label: 'forms_assets:common.enums.taxBurden.low',
    key: ETaxBurden.LOW,
  },
  {
    label: 'forms_assets:common.enums.taxBurden.no',
    key: ETaxBurden.NO,
  },
];

// TODO entities/assets/types TaxAgentList
export const TaxAgentList = [
  {
    label: 'forms_assets:debitAccount.enums.taxAgent.client',
    key: TaxAgentType.client,
  },
  {
    label: 'forms_assets:debitAccount.enums.taxAgent.bank',
    key: TaxAgentType.bank,
  },
  {
    label: 'forms_assets:debitAccount.enums.taxAgent.other',
    key: TaxAgentType.other,
  },
];

export const LegalEntityTaxAgentList = [
  {
    label: 'forms_assets:legalEntity.enums.taxAgent.client',
    key: LegalEntityTaxAgentType.client,
  },
  {
    label: 'forms_assets:legalEntity.enums.taxAgent.legalEntity',
    key: LegalEntityTaxAgentType.legalEntity,
  },
  {
    label: 'forms_assets:legalEntity.enums.taxAgent.other',
    key: LegalEntityTaxAgentType.other,
  },
];

export const HolderTaxAgentList = [
  {
    label: 'forms_assets:stocks.enums.taxAgent.client',
    key: HolderTaxAgentType.client,
  },
  {
    label: 'forms_assets:stocks.enums.taxAgent.financialInstitution',
    key: HolderTaxAgentType.financialInstitution,
  },
  {
    label: 'forms_assets:stocks.enums.taxAgent.other',
    key: HolderTaxAgentType.other,
  },
];

// TODO entities/assets/types OwnershipList
export const OwnershipList = [
  {
    label: 'forms_assets:common.enums.ownershipType.direct',
    key: OwnershipType.DIRECT,
  },
  {
    label: 'forms_assets:common.enums.ownershipType.indirect',
    key: OwnershipType.INDIRECT,
  },
  // {
  //   label: 'forms_assets:common.enums.ownershipType.joint',
  //   key: OwnershipType.JOINT,
  // },
];

export const InformationDisclosureList = [
  {
    label: 'forms_assets:common.enums.informationDisclosure.yes',
    key: DisclosureType.yes,
  },
  {
    label: 'forms_assets:common.enums.informationDisclosure.done',
    key: DisclosureType.done,
  },
  {
    label: 'forms_assets:common.enums.informationDisclosure.no',
    key: DisclosureType.no,
  },
  {
    label: 'forms_assets:common.enums.informationDisclosure.inProcess',
    key: DisclosureType.inProcess,
  },
];

export const PublicFundTaxAgentList = [
  {
    label: 'forms_assets:publicFund.enums.taxAgent.investor',
    key: PublicFundTaxAgentType.investor,
  },
  {
    label: 'forms_assets:publicFund.enums.taxAgent.fund',
    key: PublicFundTaxAgentType.fund,
  },
  {
    label: 'forms_assets:publicFund.enums.taxAgent.other',
    key: PublicFundTaxAgentType.other,
  },
];

export const TaxAgentWithBrokerList = [
  {
    label: 'forms_assets:common.enums.taxAgentWithBroker.client',
    key: TaxAgentWithBrokerType.client,
  },
  {
    label: 'forms_assets:common.enums.taxAgentWithBroker.broker',
    key: TaxAgentWithBrokerType.broker,
  },
  {
    label: 'forms_assets:common.enums.taxAgentWithBroker.other',
    key: TaxAgentWithBrokerType.other,
  },
];
